import React, { useEffect, useState } from "react";
import { loadSection } from "../../services/contentSource";
import featuresFallback from "../../data/home/features.json";

const FeatureSection = () => {
  const [data, setData] = useState<any>(featuresFallback);

  useEffect(() => {
    loadSection("features", featuresFallback as any)
      .then(({ data: main }) => {
        if (main) setData(main);
      })
      .catch((err) => {
        console.warn("Using fallback features data:", err);
      });
  }, []);

  if (!data) return null;

  return (
    <section className="feature-area mx-feature-revamp" id="features">
      <div className="container mx-container">
        <div className="mx-feature-header">
          <div className="mx-hero-badge">
            <span className="mx-hero-badge-icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
              </svg>
            </span>
            <span>{data.badgeText || "02. CORE VALUE PROPOSITION"}</span>
          </div>

          <h2 className="mx-feature-title">
            {data.title || "STEER YOUR PRODUCT. SHAPE THE FUTURE."}
          </h2>

          <p className="mx-feature-lede">
            {data.subtitle || "We empower you to lead with cutting-edge AI solutions"}
          </p>
        </div>

        <div className="mx-features-grid">
          {(data.features || []).map((feature: any, index: number) => {
            const padIndex = String(index + 1).padStart(2, "0");
            const cleanTitle = (feature.title || "").replace(/<br\s*\/?>/gi, " ");

            return (
              <div className="mx-feature-card" key={index}>
                <div className="mx-feature-card-header">
                  <span className="mx-feature-card-chip">CAPABILITY // {padIndex}</span>
                  <div className="mx-feature-card-icon">
                    <img src={feature.icon} alt="feature icon" loading="lazy" decoding="async" />
                  </div>
                </div>

                <div className="mx-feature-card-body">
                  <h3 className="mx-feature-card-title">{cleanTitle}</h3>
                  <p className="mx-feature-card-text">{feature.text}</p>
                </div>

                <div className="mx-feature-card-footer">
                  <div className="mx-feature-card-indicator">
                    <span className="mx-feature-card-bar"></span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
